import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const briefingStore = namespace('briefingStore');

@Component
export default class RefReferenceComponent extends Vue {
  @Prop(Boolean) readonly isLoading: boolean | false;

  @briefingStore.Getter
  getAddingReferenceDocuments!: Array<any>;

  @briefingStore.Mutation
  public setAddingReferenceDocuments!: (payload: any) => void;

  startIndex = 0;
  numberItemPerPage = 4;
  endIndex = this.startIndex + this.numberItemPerPage;

  @Watch('getAddingReferenceDocuments')
  onGetAddingReferenceDocumentsChange() {
    if (this.endIndex > this.getAddingReferenceDocuments.length + 1 && this.endIndex > 4) {
      this.endIndex--;
      if (this.startIndex > 0) {
        this.startIndex--;
      }
    }
  }

  removeReferenceDocument(item) {
    if (this.getAddingReferenceDocuments !== null && this.getAddingReferenceDocuments.length > 0) {
      const index = this.getAddingReferenceDocuments.indexOf(item);

      if (index !== -1) {
        this.getAddingReferenceDocuments.splice(index, 1);
        this.setAddingReferenceDocuments(this.getAddingReferenceDocuments);
      }
    }
  }

  addToReferenceDocuments() {
    this.$emit('addToReferenceDocuments');
  }

  resetAddingReferenceDocuments() {
    this.setAddingReferenceDocuments([]);
    this.startIndex = 0;
    this.endIndex = 4;
  }

  prevSlide() {
    if (this.startIndex > 0 && this.getAddingReferenceDocuments !== null) {
      this.startIndex--;
      this.endIndex--;
    }
  }

  nextSlide() {
    if (this.getAddingReferenceDocuments !== null && this.endIndex < this.getAddingReferenceDocuments.length + 1) {
      this.endIndex++;
      this.startIndex++;
    }
  }
}
